const advoAssistPostponeModalStyle = {
  spacingRight: {
    paddingRight: "1rem",
  }
}
export default advoAssistPostponeModalStyle;